import React, { useState } from "react";
import {
  motion,
  useTransform,
  AnimatePresence,
  useMotionValue,
  useSpring,
} from "framer-motion";
import { cn } from "../lib/utils";

export const AnimatedTooltip = ({
  title,
  children,
  leftAlign = false,
  bottomAlign = false,
  className,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const springConfig = { stiffness: 100, damping: 5 };
  const x = useMotionValue(0); // going to set this value on mouse move
  // rotate the tooltip
  const rotate = useSpring(
    useTransform(x, [-100, 100], [-45, 45]),
    springConfig
  );
  // translate the tooltip
  const translateX = useSpring(
    useTransform(x, [-100, 100], [-50, 50]),
    springConfig
  );

  return (
    <>
      <div
        className="relative group"
        key={title}
        onMouseEnter={() => setHoveredIndex(title)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <AnimatePresence>
          {hoveredIndex === title && (
            <motion.div
              initial={{ opacity: 0, y: 20, scale: 0.6 }}
              animate={{
                opacity: 1,
                y: 0,
                scale: 1,
                transition: {
                  type: "spring",
                  stiffness: 260,
                  damping: 10,
                },
              }}
              exit={{ opacity: 0, y: 20, scale: 0.6 }}
              style={{
                translateX: translateX,
                rotate: rotate,
                whiteSpace: "nowrap",
              }}
              className={cn(
                `absolute -top-10 flex text-xs flex-col items-center justify-center rounded-md dark:bg-white bg-black z-[90] shadow-xl px-4 py-2 ${
                  leftAlign ? "left-0" : " right-0 "
                } ${bottomAlign ? "top-10" : "-top-10"}`,
                className
              )}
            >
              {/* <div className="absolute inset-x-10 z-30 w-[20%] -bottom-px bg-gradient-to-r from-transparent via-emerald-500 to-transparent h-px " />
              <div className="absolute left-10 w-[40%] z-30 -bottom-px bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px " /> */}
              <div className="dark:text-black text-white text-xs">{title}</div>
            </motion.div>
          )}
        </AnimatePresence>
        {children}
      </div>
    </>
  );
};
